export const LOAD_ROLES = "LOAD_ROLES";
export const LOAD_ROLES_SUCCESS = "LOAD_ROLES_SUCCESS";
